import { Component, Inject, OnInit, Self } from '@angular/core';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../utils/utils';
import { takeUntil } from 'rxjs';
import { DestroyService } from '../../../services/destroyservice';
import { MatDialog } from '@angular/material/dialog';
import { EmtTdcDeploymentStatusPopup } from '../emttdcdeployment/emttdc-deploymentstatus-popup.component';

@Component({
    selector: 'manufacturingsettings',
    templateUrl: './manufacturingsettings.component.html',
    styleUrls: ['./manufacturingsettings.component.less', '../../../style/new-generic-styles.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class ManufacturingSettingsComponent implements OnInit {

    originalMfgCenterProduct: MFGCenterProductItem[] = [];
    availableCenterProducts: MFGCenterProductItem[] = [];
    availableProductUsages: EMTProductUsageItem[] = [];
    originalSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];
    availableCenters: MfgCenter[] = [];

    // TODO: before migration Angular 19
    availableFamilyCodes: any | null = null;

    constructor(private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , @Self() private readonly destroy$: DestroyService
        , private matDialog: MatDialog) { }

    ngOnInit(): void {
        this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => { this.execAllGets() });
        this.execAllGets();
    }
    resetItems() {
        this.originalMfgCenterProduct = [];
        this.originalSoftwareReleases = [];
    }

    execAllGets() {
        this.resetItems()
        this.getManufacturingCentersProducts();
        this.getSoftwareReleases();
        this.getCenters();
    }


    getManufacturingCentersProducts() {
        Utils.httpGetMfgCenterProducts(
            this.http,
            this.baseUrl,
            this,
            function (tthis: ManufacturingSettingsComponent, result: MFGCenterProduct) {
                tthis.originalMfgCenterProduct = result.centerProductList;
            }
        );
    }


    getSoftwareReleases() {
        Utils.httpGetEMTControllerSoftwareReleases(
            this.http,
            this.baseUrl,
            undefined,
            this,
            function (tthis: ManufacturingSettingsComponent, result: EMTControllerSoftwareReleases) {
                tthis.originalSoftwareReleases = result.releasesList;
            }
        );
    }

    loadCenterProduct(centerProduct: MFGCenterProductItem[]) {
        this.availableCenterProducts = centerProduct;
    }

    loadProductUsage(productUsages: EMTProductUsageItem[]) {
        this.availableProductUsages = productUsages;
    }

    getCenters() {
        Utils.httpGetMfgcenters(this.http,
            this.baseUrl,
            this,
            function (tthis: ManufacturingSettingsComponent, result: MfgCenters) {
                tthis.availableCenters = result.centersList;
            }
        );
    }

    openDeploymentInformationPopup() {
        this.matDialog.open(EmtTdcDeploymentStatusPopup, {
            panelClass: 'custom-mat-dialog',
            data: { "component": 'emttdc' }
        });
    }

    // TODO: Angular 19 COMPILED ERRORS before migration
    loadControllerSoftware($event: any | null) {}
}
